import { useEffect } from 'react';
import { useActiveEvent } from '../../contexts/EventContext';
import { useAppSelector } from '../../store';
import { syncManager } from '../../lib/syncManager';

/**
 * Component that syncs offline data for the current active event
 * Must be placed inside EventProvider to access activeEventId
 */
export default function EventDataSync() {
  const { activeEventId } = useActiveEvent();
  const { token, isAuthenticated } = useAppSelector((state) => state.auth);

  useEffect(() => {
    const downloadEventData = async () => {
      if (!isAuthenticated || !token || !navigator.onLine || !activeEventId) {
        return;
      }

      try {
        await syncManager.downloadDataForOffline(token, activeEventId);
      } catch (error) {
        console.error('Failed to download event data for offline use:', error);
      }
    };

    downloadEventData();
  }, [activeEventId, token, isAuthenticated]);

  return null; // This component doesn't render anything
}
